/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useEffect, useRef, useState } from "react";
import PreviewPDF from "../Components/Generic/PDFViewer";
import PreviewImage from "../Components/Generic/PreviewImage";
import { getFileExtensionByFileType } from "./utils";
import { useLocation } from "react-router-dom";
import DownloadDoc from "../Components/VehicleDasboard/DownloadDoc";
import { FilePreviewContext } from "../Context/dataFileContext";

export type FileDataInfo = {
  name: string | undefined;
  path: string | undefined;
  type: string | null;
};

//add events listeners timeout
const timeout = 500;

// Module-level click handler reference — set when FilePreview mounts
let _handleFileClick: ((e: Event) => void) | null = null;

/** Attach data-file click handlers immediately, without the loading-spinner guard. */
export function rescanDataFiles() {
  if (!_handleFileClick) return;
  const domFiles = document.querySelectorAll("*[data-file]");
  domFiles.forEach((el) => {
    el.removeEventListener("click", _handleFileClick!);
    el.addEventListener("click", _handleFileClick!);
  });
}

export default function FilePreview() {
  const [fileData, setFileData] = useState<FileDataInfo | null>(null);
  const location = useLocation();
  const [reload, setReload] = useState(0);
  const [
    reloadFilePreviewBecauseISetDataFile,
    setReloadFilePreviewBecauseISetDataFile,
  ] = useState<any>([]);
  const FilePreview = useContext(FilePreviewContext);
  const isMountedRef = useRef(true);
  const pendingHandlersTimeoutRef = useRef<ReturnType<typeof setTimeout>>();
  const reloadTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    // this is here so we do not need to reload the window after generating pdf file (proforma was the example that did not work)
    const nodes: any = document.querySelectorAll("*[data-file]");
    nodes.forEach((element: any) => {
      const fileName = element?.dataset.file;
      if (!reloadFilePreviewBecauseISetDataFile.includes(fileName))
        setReloadFilePreviewBecauseISetDataFile([
          ...reloadFilePreviewBecauseISetDataFile,
          fileName,
        ]);
    });
  }, [document.querySelectorAll("*[data-file]")]);

  useEffect(() => {
    window.addEventListener("load", addEventHandlers);
    setReload(Math.floor(Math.random() * 100));
    return () => {
      window.removeEventListener("load", addEventHandlers);
      removeEventHandlers();
    };
  }, [location, reloadFilePreviewBecauseISetDataFile]);

  /**
   *
   */
  useEffect(() => {
    const globalLoading = document.querySelector("#loading");
    if (
      globalLoading &&
      globalLoading.classList.contains("loadingDisabled") &&
      document.querySelectorAll("*[data-file]").length
    ) {
      pendingHandlersTimeoutRef.current = setTimeout(addEventHandlers, timeout);
    } else {
      reloadTimeoutRef.current = setTimeout(() => setReload(reload + 1), timeout);
    }
    return () => {
      clearTimeout(pendingHandlersTimeoutRef.current);
      clearTimeout(reloadTimeoutRef.current);
      removeEventHandlers();
    };
  }, [reload, FilePreview?.reloadFilePreview]);

  /**
   *
   * @returns
   */
  function removeEventHandlers() {
    const domFiles = document.querySelectorAll("*[data-file]");
    if (domFiles && domFiles.length) {
      domFiles.forEach((domFile) => {
        domFile.removeEventListener("click", domElementClick);
      });
    }
  }

  /**
   *
   */
  function addEventHandlers() {
    if (!isMountedRef.current) return;
    const loadingActive = document.getElementById("loading")?.classList.length;
    if (!loadingActive) {
      pendingHandlersTimeoutRef.current = setTimeout(addEventHandlers, 500);
      return;
    }
    const domFiles = document.querySelectorAll("*[data-file]");
    if (domFiles && domFiles.length) {
      domFiles.forEach((domFile) => {
        domFile.removeEventListener("click", domElementClick);
        domFile.addEventListener("click", domElementClick);
      });
    }
  }

  /**
   *
   * @param e
   * @returns
   */
  function domElementClick(e: any) {
    e.preventDefault();
    const file = (e.currentTarget as HTMLElement)?.getAttribute("data-file");
    if (file) {
      setFileData({
        path: file,
        name: file?.split("/").pop(),
        type: getFileExtensionByFileType(file) || "",
      });
    }
    return false;
  }

  // Keep module-level reference in sync so rescanDataFiles() uses the current handler
  useEffect(() => {
    _handleFileClick = domElementClick;
    return () => { _handleFileClick = null; };
  });

  if (!fileData) return null;

  if (fileData.type === "pdf" || fileData.type === "PDF")
    return (
      <PreviewPDF
        title={fileData?.name || ""}
        open={true}
        onClose={() => {
          setFileData(null);
        }}
        url={fileData?.path}
      />
    );

  if (
    fileData.type === "jpg" ||
    fileData.type === "png" ||
    fileData.type === "jpeg" ||
    fileData.type === "webp" ||
    fileData.type === "gif" ||
    fileData.type === "svg"
  )
    return (
      <PreviewImage
        title={fileData?.name}
        open={true}
        onClose={() => {
          setFileData(null);
        }}
        url={fileData?.path}
      />
    );

  if (
    fileData.type === "docx" ||
    fileData.type === "doc" ||
    fileData.type === "xlsx" ||
    fileData.type === "xls"
  )
    return <DownloadDoc fileData={fileData} />;
  return null;
}
